/* Lunette — espresso-shot reveal bar (November 2026).
   The espresso-shot email's button is Shopify's /discount/CODE link, redirecting with ?esp=<offer>-<YYYYMMDD>:
   offer "all" = never bought (10 % on the order), "care" = bought before (10 % on care + period panties), and the date
   is the send day from Klaviyo's {% today "%Y%m%d" as today %}. The email promises "one tap reveals it", so this bar
   shows the offer, the shopper's code (to copy onto another device) and the real time left.
   It must never advertise a code that no longer works:
   - the code stops at 23:59 store time on the send day, so the bar shows only on that day in the store's time zone
     (TZ must match the coupon's expiry; an unknown host shows nothing) and leaves at 23:59:00;
   - the email's own code is remembered at landing: the cookie Shopify's link sets, or (no cookie at all) the cart's
     only code. A cookie that matches nothing in the cart pins nothing. The bar shows only while the cart still holds
     exactly that code, never another one (e.g. a store-credit code). A failed first cart read retries on the next page;
   - Shopify keeps even a rejected code in the cart, marked applicable: false (checked 3 Nov). For "all" every item
     qualifies, so a filled cart where the code does not apply means it no longer works: no bar. An empty cart says
     nothing either way; "care" carts can hold a cup the code never covered;
   - the order going through ends the bar for the day: a cart that held items and is now empty, or an empty cart after
     a checkout click. Express buttons (Shop Pay, Apple Pay) sit in iframes, hence the items-to-empty rule; emptying the
     cart by hand ends it too, which is fine. Tapping the same email again that day does not bring it back.
     (The cart token is no help: the theme calls cart/update.js on every page.)
   Limits: a code spent on another device, or through an express "buy now" from an empty cart, still shows on an empty
   cart until midnight; a link from an earlier day is ignored and leaves today's bar alone. Text goes in through
   textContent, never as HTML. The × hides it for the visit. Runs on every page, once. Finnish lines other than
   "Yllätyksesi odottaa ostoskorissa" (live flows, Laila-reviewed) wait for Laila. */
(function () {
  if (window.__lunEspressoBound) return;
  window.__lunEspressoBound = true;
  var STATE_KEY = 'lunEsp', CODE_KEY = 'lunEspCode', PENDING_KEY = 'lunEspPending', CHECKOUT_KEY = 'lunEspCheckout',
      ITEMS_KEY = 'lunEspItems', DONE_KEY = 'lunEspDone', HIDE_KEY = 'lunEspHidden';
  var CHECKOUT_SEL = 'a[href$="/checkout"], a[href*="/checkout?"], a[href*="/checkouts/"], [name="checkout"],'
      + ' form[action$="/checkout"], form[action*="/checkout?"]';
  var END_OF_DAY_S = 23 * 3600 + 59 * 60;          // the code stops at 23:59
  var TICK_MS = 1000, COPIED_MS = 1600;
  var TAG_RE = /^(all|care)-(\d{8})$/, CODE_RE = /^[A-Za-z0-9_-]{3,40}$/;
  var INK = '#111111', ROSE = '#D985A6';
  var TZ = { 'lunette.com': 'Europe/Berlin', 'lunette.co.uk': 'Europe/London',
             'lunette.us': 'America/Los_Angeles', 'lunette.com.au': 'Australia/Sydney' }[location.hostname.replace(/^www\./, '')];
  if (!TZ) return;
  var TEXT = {
    en: { head: 'Your surprise is waiting in your cart', all: '10 % off your order', care: '10 % off care & period panties',
          ends: 'Ends in', code: 'Code', copy: 'Copy', copied: 'Copied', close: 'Close' },
    de: { head: 'Deine Überraschung wartet im Warenkorb', all: '10 % auf deine Bestellung', care: '10 % auf Pflege & Periodenunterwäsche',
          ends: 'Endet in', code: 'Code', copy: 'Kopieren', copied: 'Kopiert', close: 'Schließen' },
    fi: { head: 'Yllätyksesi odottaa ostoskorissa', all: '10 % tilauksestasi', care: '10 % hoitotuotteista ja kuukautisalushousuista',
          ends: 'Päättyy', code: 'Koodi', copy: 'Kopioi', copied: 'Kopioitu', close: 'Sulje' }
  };
  var t = TEXT[/^\/fi(\/|$)/.test(location.pathname) ? 'fi' : /^\/de(\/|$)/.test(location.pathname) ? 'de' : 'en'];

  /** @returns {{day: string, secs: number}} today (YYYYMMDD) and seconds since midnight, in the store's time zone */
  function storeClock() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: p.year + p.month + p.day, secs: +p.hour * 3600 + +p.minute * 60 + +p.second };
  }
  // Storage can be blocked (private mode, strict settings): the bar then simply works for this page view only.
  function load(area, key) { try { return window[area].getItem(key); } catch (e) { return null; } }
  function save(area, key, value) {
    try { if (value === null) window[area].removeItem(key); else window[area].setItem(key, value); } catch (e) { /* blocked */ }
  }
  function forget() {
    [STATE_KEY, CODE_KEY, PENDING_KEY, CHECKOUT_KEY, ITEMS_KEY].forEach(function (k) { save('localStorage', k, null); });
  }
  function finished(tagValue) {     // the order went through: today's link must not bring the bar back
    save('localStorage', DONE_KEY, tagValue);
    forget();
  }
  function upper(s) { return String(s).toUpperCase(); }
  function cookieCode() {
    var m = /(?:^|;\s*)discount_code=([^;]+)/.exec(document.cookie);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function hms(s) {
    return [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60].map(function (n) { return (n < 10 ? '0' : '') + n; }).join(':');
  }
  function watchCheckout() {
    function mark(e) {
      var el = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
      if (el || (e.submitter && e.submitter.name === 'checkout')) save('localStorage', CHECKOUT_KEY, '1');
    }
    document.addEventListener('click', mark, true);
    document.addEventListener('submit', mark, true);
  }

  var now = storeClock();
  var params = new URLSearchParams(location.search);
  var tag = TAG_RE.exec(params.get('esp') || '');
  if (params.has('esp')) {
    params.delete('esp');
    var q = params.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
  }
  // a tag from an earlier day is ignored (its code has stopped), and so is today's tag once that order went through
  var landing = !!(tag && tag[2] === now.day && load('localStorage', DONE_KEY) !== tag[0]);
  if (landing) {
    forget();
    save('localStorage', STATE_KEY, tag[0]);
    save('localStorage', PENDING_KEY, '1');
  }
  var state = TAG_RE.exec((landing && tag[0]) || load('localStorage', STATE_KEY) || '');
  if (!state) return;
  if (state[2] !== now.day) { forget(); return; }
  watchCheckout();

  var pinning = landing || !!load('localStorage', PENDING_KEY);   // pending until a cart read succeeds
  var pinned = pinning ? null : load('localStorage', CODE_KEY);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .catch(function () { return null; })
    .then(function (cart) {
      if (!cart) return;
      var codes = cart.discount_codes || [];
      if (pinning) {
        var cookie = upper(cookieCode());
        var mine = cookie ? codes.filter(function (d) { return upper(d.code) === cookie; })[0]
                          : (codes.length === 1 ? codes[0] : null);
        if (!mine || !CODE_RE.test(String(mine.code))) return;
        pinned = String(mine.code);
        save('localStorage', CODE_KEY, pinned);
        save('localStorage', PENDING_KEY, null);
      }
      var hit = pinned && codes.filter(function (d) { return upper(d.code) === upper(pinned); })[0];
      if (!hit || !CODE_RE.test(String(hit.code))) return;
      var items = +cart.item_count || 0;
      var before = +(load('localStorage', ITEMS_KEY) || 0);
      save('localStorage', ITEMS_KEY, String(items));
      if (items === 0 && (before > 0 || load('localStorage', CHECKOUT_KEY))) { finished(state[0]); return; }
      if (state[1] === 'all' && items > 0 && hit.applicable === false) return;
      if (load('sessionStorage', HIDE_KEY)) return;
      show(String(hit.code), state[1]);
    });

  function el(tagName, css, text) {
    var e = document.createElement(tagName);
    if (css) e.style.cssText = css;
    if (text) e.textContent = text;
    return e;
  }

  function show(code, offer) {
    var bar = el('div', 'background:' + INK + ';color:#fff;font-family:inherit;font-size:14px;line-height:1.35;position:relative;'
      + 'padding:10px 48px 10px 16px;text-align:center;z-index:30;');
    bar.id = 'lun-esp';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', t.head);
    bar.setAttribute('translate', 'no');             // our own DE/FI lines: keep Weglot from re-translating them
    bar.className = 'notranslate wg-notranslate';

    var row = el('div', 'display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:6px 18px;');
    var head = el('span', '');
    head.appendChild(el('strong', 'font-weight:700;', t.head + ': '));
    head.appendChild(el('span', 'color:' + ROSE + ';font-weight:800;', t[offer]));

    var clock = el('span', '', t.ends + ' ');
    var digits = el('b', 'color:' + ROSE + ';font-variant-numeric:tabular-nums;letter-spacing:.5px;');
    clock.appendChild(digits);

    var codeWrap = el('span', 'display:inline-flex;align-items:center;gap:8px;', t.code + ' ');
    var codeEl = el('b', 'border:1px dashed ' + ROSE + ';border-radius:6px;padding:2px 8px;letter-spacing:1px;', code);
    var copy = el('button', 'background:' + ROSE + ';color:' + INK + ';border:0;border-radius:100px;padding:5px 12px;'
      + 'font:inherit;font-size:12px;font-weight:800;cursor:pointer;', t.copy);
    copy.type = 'button';
    codeWrap.appendChild(codeEl);
    codeWrap.appendChild(copy);

    var close = el('button', 'position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:0;'
      + 'color:#fff;font-size:22px;line-height:1;padding:6px 10px;cursor:pointer;', '×');
    close.type = 'button';
    close.setAttribute('aria-label', t.close);

    row.appendChild(head);
    row.appendChild(clock);
    row.appendChild(codeWrap);
    bar.appendChild(row);
    bar.appendChild(close);
    document.body.insertBefore(bar, document.body.firstChild);

    function tick() {
      var c = storeClock();
      var left = END_OF_DAY_S - c.secs;
      if (c.day !== state[2] || left <= 0) {
        clearInterval(timer);
        forget();
        if (bar.parentNode) bar.parentNode.removeChild(bar);
        return;
      }
      digits.textContent = hms(left);
    }
    var timer = setInterval(tick, TICK_MS);
    tick();

    close.addEventListener('click', function () {
      save('sessionStorage', HIDE_KEY, '1');
      clearInterval(timer);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
    copy.addEventListener('click', function () {
      function select() {
        var r = document.createRange();
        r.selectNodeContents(codeEl);
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(r);
      }
      function done() {
        copy.textContent = t.copied;
        setTimeout(function () { copy.textContent = t.copy; }, COPIED_MS);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, select);
      else select();
    });
  }
})();
